import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import "../../../style/projects/completeProject.css";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const CompleteProject = () => {
  useEffect(() => {
    document.title = `Development Concern | Complete Project`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/complete-project";

  return (
    <div>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="complete_project_section">
        <div className="header_image">
          <p>Home | Project</p>
          <h2>Complete Projects</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2> Completed Projects </h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Our Completed Projects</h1>
          <div className="table_wrapper">
            <table>
              <thead>
                <tr>
                  <th>SL</th>
                  <th>Project Name</th>
                  <th>Donor Name</th>
                  <th>Duration</th>
                  <th>Project Ares</th>
                  <th>Major Focuses</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    Year-Round Pineapple Production Through Flower Inducing Chemicals
                    In collaboration with Agricultural Technology Transfer Project (ATT Project)
                  </td>
                  <td>
                    Bangladesh Agricultural Research Council (BARC)
                  </td>
                  <td>August 2008 to December 2010
                  </td>
                  <td>Rangamati Sadar</td>
                  <td>To grow pineapples round the year</td>
                </tr>

                <tr>
                  <td>2</td>
                  <td>Hopper and Borer Control in Mango Trees In association with AFRES Foundation
                  </td>
                  <td>
                    Bangladesh Agricultural Research Council (BARC)
                  </td>
                  <td>September 2008 to December 2010</td>
                  <td>Rangamati Sadar</td>
                  <td>To control specific kind of pests</td>
                </tr>

                <tr>
                  <td>3</td>
                  <td>Linking Small Farmers with Supermarkets through Promotion of Pre-Urban Agriculture
                  </td>
                  <td>
                    Bangladesh Agricultural Research Council (BARC)
                  </td>
                  <td>January 2009 to May 2011</td>
                  <td>Rangamati Sadar</td>
                  <td>To enable the farmers to have an access to market management</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CompleteProject;
